import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/accessControl/usePermission.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/core/auth/userProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/presentation/auth/resetPasswordForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/presentation/auth/signInForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/presentation/auth/signUpForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/presentation/auth/updatePasswordForm.tsx");
